<!-- =========================================================================================
  File Name: list.vue
  Description: User List
========================================================================================== -->

<template>
  <div id="user-list">

    <vx-card title="会员列表">

      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <vs-button class="mr-4" size="small" color="success" type="filled" @click="add">注册新会员</vs-button>
          </template>
          <template slot="prepend">
            <vs-input class="w-48" v-model="parent" placeholder="上级用户名" />
          </template>
          
          <template slot="prepend">
            <vs-select class="w-48" v-model="group_id">
              <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in groupList" />
            </vs-select>
          </template>
          
          <template slot="prepend">
            <vs-select class="w-48" v-model="isOnlineVal">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in isOnlineList" />
            </vs-select>
          </template>
          <template slot="prepend">
            <vs-select class="w-48" v-model="rangeVal">
              <vs-select-item :key="index" :value="item.val" :text="item.name" v-for="(item, index) in range" />
            </vs-select>
          </template>
          <template slot="prepend">
            <vs-select class="w-48" v-model="searchTypeVal">
              <vs-select-item :key="index" :value="item.val" :text="item.name" v-for="(item, index) in searchTypeList" />
            </vs-select>
          </template>
          <vs-input class="w-48" v-model="keyword" placeholder="关键词" />
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>

      <vs-table stripe :data="list" noDataText="暂无会员">
        <template slot="thead">
          <vs-th width="80">
            UID
            <span class="sort-th ml-1">
              <i class="material-icons up-sort" @click="orderChange" data-order="uid,1">expand_less</i>
              <i class="material-icons down-sort" @click="orderChange" data-order="uid,-1">expand_more</i>
            </span>
          </vs-th>
          <vs-th>用户名</vs-th>
          <vs-th>当前等级</vs-th>
          <vs-th>上级代理</vs-th>

          <vs-th>余额(元)
          <span class="sort-th ml-1">
            <i class="material-icons up-sort" @click="orderChange" data-order="coin,1">expand_less</i>
            <i class="material-icons down-sort" @click="orderChange" data-order="coin,-1">expand_more</i>
            </span>
          </vs-th>
          <vs-th>团队余额(元)</vs-th>
          <vs-th>团队投注(元)</vs-th>
          <vs-th>
            在线
            <span class="sort-th ml-1">
              <i class="material-icons up-sort" @click="orderChange" data-order="actionTime,1">expand_less</i>
              <i class="material-icons down-sort" @click="orderChange" data-order="actionTime,-1">expand_more</i>
            </span>
          </vs-th>
          <vs-th>
            登录时间
            <span class="sort-th ml-1">
              <i class="material-icons up-sort" @click="orderChange" data-order="loginTime,1">expand_less</i>
              <i class="material-icons down-sort" @click="orderChange" data-order="loginTime,-1">expand_more</i>
            </span>
          </vs-th>
          <vs-th>登录IP</vs-th>
          <vs-th>客户端</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.uid}}</vs-td>
            <vs-td :data="item.username">
              
              <router-link :to="{ name: 'userList', query: { parent: item.username } }">
                   {{item.username}}
                  </router-link> 
            </vs-td>
            <vs-td :data="item.groupname">{{item.groupname}}</vs-td>
            <vs-td :data="item.parentList">
              <span v-if="!item.parentList || item.parentList.length === 0">无</span>
              <span v-else>
                <span v-for="(item2, index2) in item.parentList" :key="index2">
                  <router-link :to="{ name: 'userList', query: { parent: item2 } }">
                    {{item2}}
                  </router-link> >
                </span>
              </span>
            </vs-td>

            <!-- 可输入余额 + 保存按钮 -->
            <vs-td :data="item.coin" class="flex items-center gap-2">
              <vs-input 
                v-model.number="item.coin" 
                class="w-24" 
                size="small"
                @keydown.enter="saveCoin(index)"
              />
              <vs-button 
                size="small" 
                color="primary" 
                type="filled" 
                @click="saveCoin(index)"
              >
                保存
              </vs-button>
            </vs-td>

            <vs-td :data="item.teamCoin">{{parseFloat(item.teamCoin).toFixed(4)}}</vs-td>
            <vs-td :data="item.teamCoin">{{parseFloat(item.teamBets).toFixed(2)}}</vs-td>
            <vs-td :data="item.actionTime">
              <span v-if="new Date().getTime() / 1000 - item.actionTime < 600" style="font-weight: bold; color: #ff9900;">在线</span>
              <span v-else style="color: #999999;">离线</span>
            </vs-td>
            <vs-td :data="item.actionDate">{{item.loginDate}}</vs-td>
            <vs-td :data="item.loginIP">{{item.loginIp}}</vs-td>
            <vs-td :data="item.loginAgent">{{item.loginAgent ? item.loginAgent[0] : ''}}</vs-td>
            <vs-td>
              <vs-button color="success" type="filled" size="small" @click="recharge" :data-index="index">充值</vs-button>
              <vs-button color="success" type="filled" size="small" @click="toRecord" :data-index="index">账变</vs-button>
              <vs-button color="danger" type="border" size="small" @click="kick" :data-index="index" v-if="new Date().getTime() / 1000 - item.actionTime < 600">踢人</vs-button>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index" class="ml-4">编辑</vs-button>
              <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index" class="ml-4">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" :title="modifyIndex != -1 ? '更改会员信息' : '添加会员'" @confirm="submit">
      <div class="p-4">
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.username" label="用户名" :disabled="modifyIndex != -1" />
        </div>
        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.password" label="密码" placeholder="不更改请留空" />
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.coinPassword" label="资金密码" placeholder="不更改请留空" />
            </div>
          </div>
        </div>

        <vs-divider></vs-divider>

        <div class="mb-4">
          <div class="vx-row">
            <div :class="'vx-col sm:w-1/' + (userCoin === modifyItem.coin ? 2 : 3)">
              <vs-input class="w-full" v-model="modifyItem.coin" label="余额 (元)" />
            </div>
            <div class="vx-col sm:w-1/3" v-if="userCoin !== modifyItem.coin">
              <vs-select class="w-full" v-model="logType" label="账变类型">
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in logTypeList" />
              </vs-select>
            </div>
            <div :class="'vx-col sm:w-1/' + (userCoin === modifyItem.coin ? 2 : 3)">
              <vs-input class="w-full" v-model="modifyItem.coinFreeze" label="冻结资金 (元)" />
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2">
              <vs-select class="w-full" v-model="modifyItem.gid" label="用户组">
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in groupList" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.parent" label="上级UID" />
            </div>
          </div>
        </div>

        <vs-divider></vs-divider>

        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2">
              <vs-select class="w-full" v-model="modifyItem.question" label="密保问题">
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in questionList" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.answer" label="密保答案" />
            </div>
          </div>
        </div>

        <vs-divider></vs-divider>

        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.fanDian" label="返点 (%)" />
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.salaryRate" label="日工资 (%)" />
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.bonusRate" label="分红 (%)" />
            </div>
          </div>
        </div>
        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.gameRate" label="电游 (%)" />
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.liveRate" label="真人 (%)" />
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.sportRate" label="体育 (%)" />
            </div>
          </div>
        </div>
        <div class="mb-4 mt-6">
          <vs-table stripe :data="modifyItem.salaryAdvance" noDataText="暂无规则">
            <template slot="header">
              <div class="w-full mb-2 flex items-center justify-between">
                <h5>日工资返点 (高级版)</h5>
                <vs-button color="success" size="small" @click="addRateList" data-type="salaryAdvance">添加</vs-button>
              </div>
            </template>
            <template slot="thead">
              <vs-th width="80">流水</vs-th>
              <vs-th width="80">亏损</vs-th>
              <vs-th width="80">人数</vs-th>
              <vs-th width="80">返水(%)</vs-th>
              <vs-th width="60">
                <div class="text-center w-full">操作</div>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(item, index) in modifyItem.salaryAdvance" >
                <vs-td :data="item.total">
                  <vs-input class="w-full" v-model="modifyItem.salaryAdvance[index].total" />
                </vs-td>
                <vs-td :data="item.lose">
                  <vs-input class="w-full" v-model="modifyItem.salaryAdvance[index].lose" />
                </vs-td>
                <vs-td :data="item.count">
                  <vs-input class="w-full" v-model="modifyItem.salaryAdvance[index].count" />
                </vs-td>
                <vs-td :data="item.percent">
                  <vs-input class="w-full" v-model="modifyItem.salaryAdvance[index].percent" />
                </vs-td>
                <vs-td>
                  <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="delRateList" data-type="salaryAdvance" :data-index="index">删除</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="mb-4 mt-6">
          <vs-table stripe :data="modifyItem.salaryHourAdvance" noDataText="暂无规则">
            <template slot="header">
              <div class="w-full mb-2 flex items-center justify-between">
                <h5>时薪返点 (高级版)</h5>
                <vs-button color="success" size="small" @click="addRateList" data-type="salaryHourAdvance">添加</vs-button>
              </div>
            </template>
            <template slot="thead">
              <vs-th width="80">流水</vs-th>
              <vs-th width="80">亏损</vs-th>
              <vs-th width="80">人数</vs-th>
              <vs-th width="80">返水(%)</vs-th>
              <vs-th width="60">
                <div class="text-center w-full">操作</div>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(item, index) in modifyItem.salaryHourAdvance" >
                <vs-td :data="item.total">
                  <vs-input class="w-full" v-model="modifyItem.salaryHourAdvance[index].total" />
                </vs-td>
                <vs-td :data="item.lose">
                  <vs-input class="w-full" v-model="modifyItem.salaryHourAdvance[index].lose" />
                </vs-td>
                <vs-td :data="item.count">
                  <vs-input class="w-full" v-model="modifyItem.salaryHourAdvance[index].count" />
                </vs-td>
                <vs-td :data="item.percent">
                  <vs-input class="w-full" v-model="modifyItem.salaryHourAdvance[index].percent" />
                </vs-td>
                <vs-td>
                  <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="delRateList" data-type="salaryHourAdvance" :data-index="index">删除</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="mb-4 mt-6">
          <vs-table stripe :data="modifyItem.bonusAdvance" noDataText="暂无规则">
            <template slot="header">
              <div class="w-full mb-2 flex items-center justify-between">
                <h5>分红返点 (高级版)</h5>
                <vs-button color="success" size="small" @click="addRateList" data-type="bonusAdvance">添加</vs-button>
              </div>
            </template>
            <template slot="thead">
              <vs-th width="80">流水</vs-th>
              <vs-th width="80">亏损</vs-th>
              <vs-th width="80">人数</vs-th>
              <vs-th width="80">返水(%)</vs-th>
              <vs-th width="60">
                <div class="text-center w-full">操作</div>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(item, index) in modifyItem.bonusAdvance" >
                <vs-td :data="item.total">
                  <vs-input class="w-full" v-model="modifyItem.bonusAdvance[index].total" />
                </vs-td>
                <vs-td :data="item.lose">
                  <vs-input class="w-full" v-model="modifyItem.bonusAdvance[index].lose" />
                </vs-td>
                <vs-td :data="item.count">
                  <vs-input class="w-full" v-model="modifyItem.bonusAdvance[index].count" />
                </vs-td>
                <vs-td :data="item.percent">
                  <vs-input class="w-full" v-model="modifyItem.bonusAdvance[index].percent" />
                </vs-td>
                <vs-td>
                  <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="delRateList" data-type="bonusAdvance" :data-index="index">删除</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="mb-4 mt-6">
          <vs-table stripe :data="modifyItem.bonusDayAdvance" noDataText="暂无规则">
            <template slot="header">
              <div class="w-full mb-2 flex items-center justify-between">
                <h5>日分红返点 (高级版)</h5>
                <vs-button color="success" size="small" @click="addRateList" data-type="bonusDayAdvance">添加</vs-button>
              </div>
            </template>
            <template slot="thead">
              <vs-th width="80">流水</vs-th>
              <vs-th width="80">亏损</vs-th>
              <vs-th width="80">人数</vs-th>
              <vs-th width="80">返水(%)</vs-th>
              <vs-th width="60">
                <div class="text-center w-full">操作</div>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(item, index) in modifyItem.bonusDayAdvance" >
                <vs-td :data="item.total">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvance[index].total" />
                </vs-td>
                <vs-td :data="item.lose">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvance[index].lose" />
                </vs-td>
                <vs-td :data="item.count">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvance[index].count" />
                </vs-td>
                <vs-td :data="item.percent">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvance[index].percent" />
                </vs-td>
                <vs-td>
                  <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="delRateList" data-type="bonusDayAdvance" :data-index="index">删除</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="mb-4 mt-6">
          <vs-table stripe :data="modifyItem.bonusDayAdvanceFixed" noDataText="暂无规则">
            <template slot="header">
              <div class="w-full mb-2 flex items-center justify-between">
                <h5>日分红返点 (高级固定版)</h5>
                <vs-button color="success" size="small" @click="addRateList" data-type="bonusDayAdvanceFixed">添加</vs-button>
              </div>
            </template>
            <template slot="thead">
              <vs-th width="80">流水</vs-th>
              <vs-th width="80">亏损</vs-th>
              <vs-th width="80">人数</vs-th>
              <vs-th width="80">分红</vs-th>
              <vs-th width="60">
                <div class="text-center w-full">操作</div>
              </vs-th>
            </template>
        
            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(item, index) in modifyItem.bonusDayAdvanceFixed" >
                <vs-td :data="item.total">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvanceFixed[index].total" />
                </vs-td>
                <vs-td :data="item.lose">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvanceFixed[index].lose" />
                </vs-td>
                <vs-td :data="item.count">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvanceFixed[index].count" />
                </vs-td>
                <vs-td :data="item.amount">
                  <vs-input class="w-full" v-model="modifyItem.bonusDayAdvanceFixed[index].amount" />
                </vs-td>
                <vs-td>
                  <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="delRateList" data-type="bonusDayAdvanceFixed" :data-index="index">删除</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <vs-divider></vs-divider>

        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.infoName" label="真实姓名" />
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.infoMobile" label="手机号" />
            </div>
          </div>
        </div>
        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.infoEmail" label="邮箱" />
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.infoWechat" label="微信号" />
            </div>
            <div class="vx-col sm:w-1/3">
              <vs-input class="w-full" v-model="modifyItem.infoQq" label="QQ号" />
            </div>
          </div>
        </div>

        <vs-divider></vs-divider>

        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.bankLock" label="锁定银行">
                <vs-select-item value="1" text="锁定" />
                <vs-select-item value="0" text="不锁定" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.isDelete" label="封号">
                <vs-select-item value="1" text="封号" />
                <vs-select-item value="0" text="正常" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.canBet" label="下注">
                <vs-select-item value="1" text="可以" />
                <vs-select-item value="0" text="禁止" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.canActivity" label="活动">
                <vs-select-item value="1" text="可以" />
                <vs-select-item value="0" text="禁止" />
              </vs-select>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.canSalary" label="工资">
                <vs-select-item value="1" text="可以" />
                <vs-select-item value="0" text="禁止" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.canBonus" label="分红">
                <vs-select-item value="1" text="可以" />
                <vs-select-item value="0" text="禁止" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.canRecharge" label="充值">
                <vs-select-item value="1" text="可以" />
                <vs-select-item value="0" text="禁止" />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.canCash" label="提现">
                <vs-select-item value="1" text="可以" />
                <vs-select-item value="0" text="禁止" />
              </vs-select>
            </div>
          </div>
        </div>
				
        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4">
              <vs-select class="w-full" v-model="modifyItem.canTransfer" label="转账">
                <vs-select-item value="1" text="可以" />
                <vs-select-item value="0" text="禁止" />
              </vs-select>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.registerDomain" label="代理专属域名" />
        </div>
        <div class="mb-4">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.createDate" label="注册时间" disabled />
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input class="w-full" v-model="modifyItem.createIp" label="注册IP" disabled />
            </div>
          </div>
        </div>

      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

export default {
  data() {
    return {
      searchTypeList: [
        {
          name: '搜索条件',
          val: ''
        },
        {
          name: '用户名',
          val: 'username'
        },
        {
          name: 'UID',
          val: 'uid'
        },
        {
          name: 'IP',
          val: 'loginIp'
        }
      ],
      searchTypeVal: 'username',
      keyword: '',
      isOnlineList: ['是否在线', '在线', '离线'],
      isOnlineVal: 0,
      parent: '',
      orderby: 'loginTime,-1',
      page: 1,
      totalPage: 1,
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      groupList: [],
      questionList: [
        '您的车牌号码',
        '您所在的城市',
        '您的生日',
        '您的名字',
        '您父亲的名字',
        '您母亲的名字',
        '您儿女的名字',
        '您妻子的名字',
        '您喜欢的数字',
        '您喜欢的品牌',
        '您喜欢的运动',
        '您喜欢的颜色',
        '您喜欢的球队',
        '您喜欢的球星'
      ],
      logTypeList: [],
      logType: '',
      userCoin: 0,
      range: [{ val: '', name: '范围' }, { val: 'self', name: '自身' }, { val: 'team', name: '团队' }],
      rangeVal: '',
      group_id:''
    }
  },
  components: {
    modifySiderBar,
  },
  methods: {

    // 保存余额（列表直接修改）→ 终极修复：loading 彻底消失
    async saveCoin(index) {
      const item = this.list[index]

      try {
        // 直接请求，不使用会卡死的 vs-loading
        await this.$utils.post('user-updateCoin', {
          authKey: localStorage.getItem('authKey'),
          uid: item.uid,
          coin: item.coin
        })

        // 成功提示
        this.$vs.notification({
          color: 'success',
          title: '成功',
          text: '余额修改完成'
        })

      } catch (err) {
        // 失败提示
        this.$vs.notification({
          color: 'danger',
          title: '失败',
          text: '修改失败'
        })
      }
    },

    add () {
      this.modifyIndex = -1
      this.modifyItem = {}
      this.modifyItem.salaryAdvance = []
      this.modifyItem.salaryHourAdvance = []
      this.modifyItem.bonusAdvance = []
      this.modifyItem.bonusDayAdvance = []
      this.modifyItem.bonusDayAdvanceFixed = []
      this.modifyItem.bankLock = 0
      this.modifyItem.isDelete = 0
      this.modifyItem.canBet = 1
      this.modifyItem.gid = 1
      this.$refs.modifySiderBar.open()
    },
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.modifyItem.password = ''
      this.modifyItem.coinPassword = ''
      this.modifyItem.salaryAdvance = this.rateListFormat(this.modifyItem.salaryAdvance)
      this.modifyItem.salaryHourAdvance = this.rateListFormat(this.modifyItem.salaryHourAdvance)
      this.modifyItem.bonusAdvance = this.rateListFormat(this.modifyItem.bonusAdvance)
      this.modifyItem.bonusDayAdvance = this.rateListFormat(this.modifyItem.bonusDayAdvance)
      this.modifyItem.bonusDayAdvanceFixed = this.rateListFormat(this.modifyItem.bonusDayAdvanceFixed)
      this.userCoin = this.modifyItem.coin
      this.logType = '调整'
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = JSON.parse(JSON.stringify(this.modifyItem))
      postdata.authKey = localStorage.getItem('authKey')
      postdata.salaryAdvance = JSON.stringify(postdata.salaryAdvance)
      postdata.salaryHourAdvance = JSON.stringify(postdata.salaryHourAdvance)
      postdata.bonusAdvance = JSON.stringify(postdata.bonusAdvance)
      postdata.bonusDayAdvance = JSON.stringify(postdata.bonusDayAdvance)
      postdata.bonusDayAdvanceFixed = JSON.stringify(postdata.bonusDayAdvanceFixed)
      postdata.logType = this.logType
      this.$utils.post(this.modifyIndex === -1 ? 'user-add' : 'user-update', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
        this.$refs.modifySiderBar.close()
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.uid = this.list[index].uid
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该会员吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('user-delete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    kick (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.uid = this.list[index].uid
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认踢该会员下线吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('user-kick', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list[index].actionTime = 0
          })
        }
      })
    },
    toRecord (e) {
      const index = e.currentTarget.dataset.index
      const uid = this.list[index].uid
      this.$router.push({ name: 'recordUser', query: { uid: uid } })
    },
    orderChange(e) {
      const order = e.currentTarget.dataset.order
      if (this.orderby === order) return
      this.orderby = order
      this.load()
    },
    search() {
      this.page = 1
      this.load()
    },
    load() {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.parent = this.parent
      postdata.searchType = this.searchTypeVal
      postdata.keyword = this.keyword
      postdata.isOnline = this.isOnlineVal
      postdata.orderby = this.orderby
      postdata.page = this.page
      postdata.range = this.rangeVal
      postdata.group_id = this.group_id
      this.$utils.post('user-list', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    addRateList (e) {
      const type = e.currentTarget.dataset.type
      this.modifyItem[type].push({})
    },
    delRateList (e) {
      const type = e.currentTarget.dataset.type
      const index = e.currentTarget.dataset.index
      this.modifyItem[type].splice(index, 1)
    },
    rateListFormat (rateList) {
      if (typeof rateList === 'object') return rateList
      try {
        rateList = JSON.parse(rateList)
      } catch (e) {
        rateList = []
      }
      return rateList
    },
    queryFromRoute() {
      const query = this.$route.query
      if (query.parent) this.parent = query.parent
    },
    recharge(e) {
      const index = e.currentTarget.dataset.index
      this.$emit('callRecharge', this.list[index].username)
    }
  },
  watch: {
    '$route'() {
      this.page = 1
      this.queryFromRoute()
      this.load()
    },
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  mounted () {
    this.queryFromRoute()
    this.load()

    // 获取用户组列表
    this.$utils.post('user-groupList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.groupList = res
    })

    // 获取账变类型
    this.$utils.post('record-userLogType', { authKey: localStorage.getItem('authKey') }).then(res => {
      for (let i = 0; i < res.length; i++) {
        this.logTypeList.push(res[i])
      }
    })
  }
}
</script>